export default __webpack_public_path__ + "static/7-e9e196c39f48b21a5fb3342023ff0bfa.jpg";